// colors

export const Colors = {
    primary100: "#134780",
    primary90: "#2b598d",
    primary80: "#426c99",
    primary70: "#5a7ea6",
    primary60: "#7191b3",
    // primary50: "#89a3c0",
    primary50: "#b8c8d9",
    primary40: "#a1b5cc",
    primary30: "#b8c8d9",
    primary20: "#d0dae6",
    primary10: "#e7edf2",
    primary5: "#f3f6f9",
    secondary100: "#1072ba",
    secondary90: "#2880c1",
    secondary80: "#408ec8",
    secondary70: "#589ccf",
    secondary60: "#70aad6",
    secondary50: "#88b9dd",
    secondary40: "#9fc7e3",
    secondary30: "#b7d5ea",
    secondary20: "#cfe3f1",
    secondary10: "#e7f1f8",
    secondary5: "#f3f8fc",
    neutral100: "#29343f",
    neutral90: "#3e4852",
    neutral80: "#545d65",
    neutral70: "#697179",
    neutral60: "#7f858c",
    neutral50: "#949a9f",
    neutral40: "#a9aeb2",
    neutral30: "#bfc2c5",
    neutral20: "#d4d6d9",
    neutral10: "#eaebec",
    neutral5: "#f2f3f5",
    neutral2: "#f8f8f9",
    alertsred100: "#ec5159",
    alertsred90: "#ee626a",
    alertsred80: "#f0747a",
    alertsred70: "#f2858b",
    alertsyellow100: "#ffb220",
    alertsyellow90: "#ffba36",
    alertsyellow80: "#ffc14d",
    alertsyellow70: "#ffc963",
    alertsgreen100: "#2eb87e",
    alertsgreen90: "#43bf8b",
    alertsgreen80: "#58c698",
    alertsgreen70: "#6dcda5",
    white: "#ffffff",
    };
//